import { render, staticRenderFns } from "./UpgradePage.vue?vue&type=template&id=575f65c1"
import script from "./UpgradePage.vue?vue&type=script&lang=js"
export * from "./UpgradePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports